import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { isEmpty } from 'lodash';

import { Lab } from 'common/graphqlTypes';
import log from 'common/ScalyrLogger';

import { settingsState } from 'components/common/Managers/SettingsManager.state';
import { accountDataState, labsState } from 'components/account/account.state';

const prepareLabs = (labs: Array<Lab>): Record<string, string> => labs.reduce((accumulator: Record<string, string>, currentValue: Lab) => {
  if (!currentValue.required) {
    accumulator[`lab_${currentValue.name}`] = currentValue.enabled ? 'enabled' : 'disabled)';
  }
  return accumulator;
}, {});

const APP_IDENTIFIER = 'scalyr-webapp';
/**
 * This component manages and sends data to Pendo by adding a script to html.
 * https://support.pendo.io/hc/en-us/articles/360031862272-Installation-for-Single-Page-Frameworks
 */
function PendoManager(): null {
  const labs = useRecoilValue(labsState);
  const accountData = useRecoilValue(accountDataState);
  const { displayMode, showSidebar, theme } = useRecoilValue(settingsState);

  useEffect(() => {
    if (!isEmpty(accountData)) {
      const pendoData = {
        visitor: {
          id: accountData?.id,
          email: accountData?.email,
          app: APP_IDENTIFIER,
          activeTeamPermission: accountData?.activeTeamPermission,
          displayMode,
          showSidebar,
          theme,
          ...prepareLabs(labs),
        },
        account: {
          id: accountData?.activeTeamId,
          billingAccountId: accountData?.masterAccountId,
        },
      };

      // If this visitor ID has not been seen before, pendo will initialize it.
      window.pendo?.initialize(pendoData);
      // If this visitor ID has been seen, update the meta data for that vistor. Pendo does this automagically.
      window.pendo?.updateOptions(pendoData);
      log.debug('Pendo initialized', pendoData);
    }

  }, [accountData, displayMode, showSidebar, theme, labs]);

  return null;
}

export default PendoManager;
